<template>
  <div>
    <div class="section">
      <div class="container">
        <div class="section__content center login">
            <h1 v-if="mobiflix_res_sub == ''">
              {{$t("unsubscription")}}
            </h1>
            <h1 v-else>
              {{mobiflix_res_sub}}
            </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";

const proxyurl = "https://cors-anywhere.herokuapp.com/"; //prevent CORS

export default {
  computed: mapGetters(["lang_Mobif", "gcid_Mobif", "country_Mobif","mobiflix_res_sub"])
};
</script>

<style lang="scss" scoped>
.section__content.login {
  max-width: 780px;
  width: 100%;
  margin: 0 auto;
  color: #fff;
  text-align: center;
}
input.mobiForElm__input {
  direction: ltr;
}
.alert {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/mobiflix/Unsubscription.vue